import React, { useEffect, useRef, useState } from "react";
import { Validators } from "../../library/utilities/Validator";
import InputField from "../../library/components/InputField";
import TextFieldRegional from "../../library/components/TextFieldRegional/TextFieldRegional";
import {
  addTranslationScript,
  downloadFile,
  parseJwt,
  previewFile,
} from "../utilities/utils";
import UploadFile from "../../library/components/FileUpload";
import { objectStoreApi } from "../../services/objectStoreServices";
import Button from "../../library/components/Button";
import { useCreateBallotMutation } from "../../services/epbAndEpbPinService";
import none from "../../dashboardicon/none.jpg";
import up from "../../dashboardicon/up.svg";
import down from "../../dashboardicon/down.svg";
import { useGetStateLangQuery } from "../../services/User_management/userService";
import { BallotOutlined } from "@mui/icons-material";
import {
  useGetBallotCandidateQuery,
  useSaveBallotCandidatesMutation,
} from "../../services/announceElection";
import { ALERT_TYPE_INFO, BASE_URLS, PLATFORM_TYPE } from "../../constants/constants";
import axios from "axios";
import { createAlert } from "../../features/alert/alerts";
import { useDispatch } from "react-redux";
import "./ballotCreation.css"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button1 from "react-bootstrap/Button";
import back from "../../dashboardicon/back.svg";
import { useNavigate } from "react-router-dom";

const BallotCreation = () => {
  const [state, setState] = useState();
  const [uploadFlag, setUploadFlag] = useState(false);
  const [files, setFiles] = useState();
  const [FileError, setFileError] = useState();
  const [errorValue, setErrorValue] = useState({});
  const [uploadType, setUploadType] = useState("");
  const [deleteFileFlag, setDeleteFileFlag] = useState(true);
  const [filesKey, setFilesKey] = useState("");
  var [ballotData, setballotData] = useState([]);
  const refFirstName = useRef(null);
  const formRef = useRef(null);
  const refpartyName = useRef(null);
  const [languageByAc, setLanguageByAc] = useState("");
  const [pdf, setpdf] = useState("");
  const [clears, setClear] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showNota, setShowNota] = useState(false);
  const [showAdd, setShowAdd] = useState(true);
  var [uploadData] = objectStoreApi.useSubmitObjectStoreUploadMutation();
  const [saveBallot, datap] = useCreateBallotMutation();
  const { data, isSuccess } = useGetStateLangQuery();
  const [saveAsDraft, datas] = useSaveBallotCandidatesMutation();
  const [prevRes, setPrevRes] = useState([]);
 const [changeObserveonUpdate,setchangeObserveonUpdate] = useState(false)
 const ref = useRef()
 const dispatch = useDispatch()
const navigate = useNavigate()

 const fetchData = async () => {
  const header1 = {
    headers: {
      Authorization: "Bearer " + localStorage.access_token,
      constType: parseJwt(localStorage.access_token)?.constituencyType,
      constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0],
      currentRole: localStorage.userrole,
      atkn_bnd: localStorage?.atkn_bnd,
      rtkn_bnd: localStorage?.rtkn_bnd,
      channelidobo: "ETPBMS",    
      "PLATFORM-TYPE":PLATFORM_TYPE
    },
  };
  const header2 = {
    headers: {
      Authorization: "Bearer " + localStorage.access_token,
      currentRole: localStorage.userrole,
      appName: "ETPBMS",
      atkn_bnd: localStorage?.atkn_bnd,
      rtkn_bnd: localStorage?.rtkn_bnd,
      channelidobo: "ETPBMS", 
      "PLATFORM-TYPE":PLATFORM_TYPE   
    },
  };
  const { data: response } = await axios.get(
    BASE_URLS.ANNOUNCE_ELECTION_BASE_URL +
      `v1/public/announceElection/getBallotDetails`,
    header1
  );
  const updatedArray = await Promise.all(
    response?.payload?.ballotDetailsProjection?.map(async (item) => {
      const { data: additionalDataResponse } = await axios.get(
        BASE_URLS.OBJECTSTORE_BASE_URL +
          `api/v1/document/getFile?bucketName=objectstorage&fileName=${item?.photoPath}`,
        header2
      );
      return {
        name_en: item?.enName,
        name_L1: item?.lname,
        party_en: item?.enPartyName,
        party_L1: item?.l1PartyName,
        photoDocument: item?.photoPath,
        file: `data:${"image/jpeg"};base64,` + additionalDataResponse.file,
      };
    })
  );
  setPrevRes(updatedArray);
  setballotData(updatedArray);
};

  useEffect(() => {
    fetchData();
  }, [datas]);

  useEffect(() => {
    if (isSuccess) {
      setLanguageByAc(data?.payload?.stateNameEn);
    }
  }, [data, isSuccess]);

  const handleChange = (key, value, valueName) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  useEffect(() => {
    const removeScript = addTranslationScript();
    return removeScript;
  }, []);

  useEffect(() => {
    if (datap.isSuccess) {
      setpdf(URL.createObjectURL(datap?.data));
    }
  }, [datap.isSuccess]);

  const getConversion = () => {
    window.enableTyping(
      ["firstname", "partyName", "fNameR", "fNameSur", "fNameSurname"],
      [
        "regfirstname",
        "regpartyName",
        "regSName",
        "regRelatName",
        "regRelatSurName",
      ],
      "NAME",
      languageByAc ? languageByAc : "en_in",
      false
    );
  };

  useEffect(() => {
    getConversion();
  });

  const changeHandler1 = (event, key) => {
    setState((prev) => ({
      ...prev,
      [key]: event.target.files[0],
      fileUrl: URL.createObjectURL(event.target.files[0]),
      defaultValue: URL.createObjectURL(event.target.files[0]),
    }));
    let files = event.target.files[0];
    let objKey = "photoDocument";
    setUploadFlag(true);
    setFilesKey(objKey);
    setFiles({ ...files, [objKey]: files });
  };
  const resetFile1 = (resetType, key) => {
    setUploadType(resetType);
    setDeleteFileFlag(false);
    setState({ ...state, [key]: "", photo: "" });
    if (state[key] && !FileError) setDeleteFileFlag(false);
  };

  useEffect(() => {
    if (uploadFlag && filesKey === "photoDocument") {
      const ACNo = parseJwt(localStorage.access_token)?.authorizedAcs?.[0];
      const State = parseJwt(localStorage.access_token)?.authorizedStates?.[0];
      const ACType = parseJwt(localStorage.access_token)?.constituencyType;
      let formdata = new FormData();
      formdata.append("bucketName", "objectstorage");
      formdata.append("file", files[filesKey]);
      formdata.append("fileType", files[filesKey].type);
      formdata.append("fileName", `${"photo"}`);
      formdata.append("stateCode", State);
      formdata.append("acNo", `CAN_PHOTO_${ACType}_${ACNo}`);
      formdata.append("type", `ETPBMS`);
      if (formdata !== null && !FileError) {
        uploadData(formdata)
          .then((res) => {
            setState({ ...state, [filesKey]: res.data.refId });
          })
          .catch((err) => {});
        setFiles({});
        setUploadFlag(false);
      }
    }
  }, [files]);

  const addData = () => {
    let error = {};
    if (!state?.firstName || state?.firstName === "") {
      error["firstName"] = "This field is required";
    }

    if (!refFirstName?.current?.value || refFirstName?.current?.value === "") {
      error["firstNameL"] = "This Field is required";
    }

    if ((!state?.partyName || state?.partyName === "") && !showNota) {
      error["partyName"] = "This Field is required";
    }

    if ((!state?.photo || state?.photo === "") && !showNota) {
      error["photo"] = "This Field is required";
    }

    if (
      (!refpartyName?.current?.value || refpartyName?.current?.value === "") &&
      !showNota
    ) {
      error["partyNameL"] = "This Field is required";
    }

    if (Object.keys(error).length) {
      setErrorValue(error);
      return;
    }
    const filteredOptionsNoneOftheAbove = ballotData.filter((existingOption) => existingOption?.name_en === 'NONE OF THE ABOVE');
    console.log(filteredOptionsNoneOftheAbove)
    const filteredOptions = ballotData.filter((existingOption) => existingOption?.name_en !== 'NONE OF THE ABOVE');
   // Add the new option
   console.log(filteredOptions)
   setballotData([...filteredOptions, {
    name_en: state?.firstName,
    name_L1: refFirstName?.current?.value,
    party_en: state?.partyName,
    party_L1: refpartyName?.current?.value,
    photoDocument: state?.photoDocument,
    photo: state?.photo,
    file: state?.fileUrl,
    id: state?.id,
  },]);
   // If the new option is not "NONE OF THE ABOVE," add it back at the end
   if (state?.firstName !== 'NONE OF THE ABOVE' && filteredOptionsNoneOftheAbove?.length>0) {
    setballotData((prevOptions) => [...prevOptions, filteredOptionsNoneOftheAbove?.[0]]);
    console.log(ballotData,filteredOptionsNoneOftheAbove?.[0])
   }

    // setballotData((prev) => [
    //   ...prev,
    //   {
    //     name_en: state?.firstName,
    //     name_L1: refFirstName?.current?.value,
    //     party_en: state?.partyName,
    //     party_L1: refpartyName?.current?.value,
    //     photoDocument: state?.photoDocument,
    //     photo: state?.photo,
    //     file: state?.fileUrl,
    //     id: state?.id,
    //   },
    // ]);
    setShowNota(false);
  };
  console.log(ballotData)
  const getErrorValue = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setErrorValue({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setErrorValue(error);
    }
  };

  useEffect(() => {
    if (ballotData.length > 0) {
      setState({});
      formRef.current.reset();
    }
  }, [ballotData, setballotData]);

  const saveData = () => {
    const data = [];
    const constType = parseJwt(localStorage?.access_token)?.constituencyType;
    ballotData?.map((item) => {
      data.push({
        lname: item?.name_L1,
        enName: item?.name_en,
        lpartyName: item?.party_L1,
        enPartyName: item?.party_en,
        candidatePhoto: item?.photoDocument,
      });
    });
    saveBallot({
      ballotRecords: data,
      constType: constType,
      lang: languageByAc,
    });
  };

  const editData = (i) => {
    if (ballotData?.[i]?.name_en == "NONE OF THE ABOVE") {
      setShowNota(true);
    }
    setShowAdd(false);
    setShowUpdate(true);
    refpartyName.current.value = ballotData?.[i]?.party_L1;
    refFirstName.current.value = ballotData?.[i]?.name_L1;
    console.log(ballotData?.[i]);
    setState({
      firstName: ballotData?.[i]?.name_en,
      partyName: ballotData?.[i]?.party_en,
      party_L1: refpartyName?.current?.value,
      name_L1: refFirstName?.current?.value,
      defaultValue: ballotData?.[i]?.file,
      photoDocument: ballotData?.[i]?.photoDocument,
      fileUrl: ballotData?.[i]?.file,
      index: i,
      id: ballotData?.[i]?.id,
    });
  };

  const deleteData = (i) => {
    const arrayOfNumbers = [1, 2, 3, 4];
    const previousSecondElementOfTheArray = ballotData.splice(i, 1);
    setPrevRes([...prevRes,previousSecondElementOfTheArray?.[0]])
    setballotData(ballotData); // [1, 3, 4]

    setState({});
  };

console.log(prevRes.length,ballotData.length)

  const updateData = () => {
    setchangeObserveonUpdate(true)
    setShowAdd(true);
    setShowUpdate(false);
    setShowNota(false);
    setballotData((prevVal) => {
      prevVal[state?.index].name_en = state?.firstName;
      prevVal[state?.index].name_L1 = refFirstName?.current?.value;
      prevVal[state?.index].party_en = state?.partyName;
      prevVal[state?.index].party_L1 = refpartyName?.current?.value;
      prevVal[state?.index].photoDocument = state?.photoDocument;
      prevVal[state?.index].file = state?.fileUrl;
      return prevVal;
    });
    setClear(true);
  };

  useEffect(() => {
    if (clears === true) {
      setState({});
      formRef.current.reset();
      setClear(false);
    }
  }, [clears, setClear]);



  const addNota = () => {
    // ballotData.filter((item)=>{
    //  if( item.name_en === "NONE OF THE ABOVE"){
    //   return null
    //  }
    // })
    if (ballotData.find(function (item) {return item.name_en == "NONE OF THE ABOVE" })) {
      onInfo(" Nota Already Added")
      return;
    }
    // setState({})
    ref.current.removeFile();
    formRef.current.reset();
    setShowNota(true);
    setState({
      firstName: "NONE OF THE ABOVE",
      partyName: "",
      party_L1: "",
      name_L1: "",
      defaultValue: none,
      photoDocument:
        "S05/ETPBMS/CAN_PHOTO_PC_undefined/10fc54c4-17e5-41f5-8db5-fa7ae041657f_NOTA.png",
      fileUrl: none,
      id: "nota",
    });
  };

  const saveDataAsDraft = () => {
    const data = [];
    const constType = parseJwt(localStorage?.access_token)?.constituencyType;
    ballotData?.map((item) => {
      data.push({
        lname: item?.name_L1,
        enName: item?.name_en,
        lpartyName: item?.party_L1,
        enPartyName: item?.party_en,
        photopath: item?.photoDocument,
        electionType: "gen",
      });
    });

    saveAsDraft({ ballotDetailsDto: data, ballotPath: "", flag: "Save" }).then((res)=>{
      setchangeObserveonUpdate(false)
      fetchData()
    });
  };

  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };


  const handleSwapUp = (index) => {
    
    if (index > 0) {
      const updatedRows = [...ballotData];
      [updatedRows[index], updatedRows[index - 1]] = [updatedRows[index - 1], updatedRows[index]];
      setballotData(updatedRows);
    }
  };
  const handleSwapDown = (index) => {
    console.log(ballotData,index)
    if (ballotData?.[index+1]?.name_en=="NONE OF THE ABOVE") {
      onInfo(" Nota Already Added")
      return;
    }
    if (index < ballotData.length - 1) {
      const updatedRows = [...ballotData];
      [updatedRows[index], updatedRows[index + 1]] = [updatedRows[index + 1], updatedRows[index]];
      setballotData(updatedRows);
    }
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      You have Updated / Added something so kindly do Save As Draft first
    </Tooltip>
  );


  return (
    <>
     <div className="container-fluid ">
      <div className="row mt-2 ml-2" style={{ fontSize:"17px", cursor:"pointer",width:"max-content"}} onClick={()=>{navigate("/ro/dashboard")}}>
        <img src={back} style={{width:"50px",height:"30px",paddingRight:"10px"}} /> back
      </div>
     </div>
      <div className="container box my-4">
      <div className="row ballotCreationTableHeader mb-2" >
      <h6 className="mx-auto">Ballot Generation </h6>
     </div>
        <form ref={formRef}>
          <div className="row">
            <div className="col-lg-9">
              <div className="row p-2">
                <InputField
                  label={"Name"}
                  id="firstname"
                  placeholder="Candidate Name (In English)"
                  name="firstName"
                  required={true}
                  type="text"
                  inputClass="col-md-5"
                  labelClass="col-md-2"
                  value={state?.firstName}
                  onChange={(val) => handleChange("firstName", val)}
                  getError={(val) => getErrorValue("firstname", val)}
                  Error={errorValue}
                />
                <TextFieldRegional
                  refValue={refFirstName}
                  name="firstNameL"
                  id="regfirstname"
                  placeholder="Candidate Name (In Vernacular)"
                  labelClass="col-md-0"
                  inputClass="col-md-5"
                  iconclass="fa fa-keyboard-o"
                  lang={languageByAc}
                  onChange={(val) => handleChange("regFirstName", val)}
                  getError={(val) => getErrorValue("firstNameL", val)}
                  Error={errorValue}
                ></TextFieldRegional>
              </div>
              <div className="row p-2">
                <InputField
                  label={"Party Name"}
                  id="partyName"
                  placeholder="Party Name (In English)"
                  name="partyName"
                  disabled={showNota}
                  required={true}
                  type="text"
                  inputClass="col-md-5"
                  labelClass="col-md-2"
                  value={state?.partyName}
                  onChange={(val) => handleChange("partyName", val)}
                  getError={(val) => getErrorValue("partyName", val)}
                  Error={errorValue}
                />
                <TextFieldRegional
                  refValue={refpartyName}
                  disabled={showNota}
                  name="partyNameL"
                  id="regpartyName"
                  placeholder="Part Name (In Vernacular)"
                  labelClass="col-md-0"
                  inputClass="col-md-5"
                  iconclass="fa fa-keyboard-o"
                  lang={languageByAc}
                  onChange={(val) => handleChange("regpartyName", val)}
                  getError={(val) => getErrorValue("partyNameL", val)}
                  Error={errorValue}
                ></TextFieldRegional>
              </div>
            </div>
            <div className="col-lg-3">
              <div
                className="col-md-12"
                style={{
                  display: "flex",
                  paddingTop: "8px",
                  flexDirection: "column",
                }}
              >
                <div className="row" style={{ flexDirection: "column" }}>
                  <UploadFile
                    id="photo"
                    name="photo"
                    labelClass="col-md-0"
                    inputClass="col-md-12 "
                    disabled={showNota}
                    validTypes={[".jpg", ".jpeg", ".png"]}
                    accept=".jpeg, .jpg, .png"
                    value={state?.photo}
                    onChange={(ev) => changeHandler1(ev, "photo")}
                    required={true}
                    size={2000}
                    reference={ref}
                    resetFile={() =>
                      resetFile1(state?.photoDocument, "photoDocument")
                    }
                    getError={(val) => getErrorValue("photo", val)}
                    Error={errorValue}
                  />
                </div>
                <div className="row">
                  {state?.photoDocument ? (
                    <>
                      <div
                        className="col-md-12"
                        style={{ textAlign: "center" }}
                      >
                        <a
                          className="link"
                          download={true}
                          tabIndex={0}
                          onKeyPress={(e) =>
                            e.key === "Enter"
                              ? downloadFile(state?.photoDocument)
                              : ""
                          }
                          onClick={() => {
                            downloadFile(state?.photoDocument);
                          }}
                        >
                          {
                            state?.photoDocument.split("_")[
                              state?.photoDocument.split("_").length - 1
                            ]
                          }
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-md-12" style={{ textAlign: "center" }}>
                {state?.photoDocument ? (
                  <img
                    style={{ height: "60px", width: "60px" }}
                    src={state?.defaultValue}
                  />
                ) : null}
              </div>
            </div>
          </div>
          <div className="row" style={{ justifyContent: "space-between" }}>
            <div style={{ marginLeft: "20px" }}>
              {showAdd && (
                <Button
                  onClick={() => {
                    addNota();
                  }}
                  btnClass="btn btn-info  "
                  value="Add Nota"
                />
              )}
            </div>
            <div style={{ marginRight: "20px" }}>
              {showAdd && (
                <Button
                  onClick={() => {
                    addData();
                  }}
                  btnClass="btn btn-danger "
                  value="Add"
                />
              )}
              {showUpdate && (
                <Button
                  onClick={() => {
                    updateData();
                  }}
                  btnClass="btn btn-danger "
                  value="Update"
                />
              )}
              <Button1
                disabled={
                  (prevRes.length == ballotData.length && prevRes.length != 0 && !changeObserveonUpdate)
                    ? false
                    : true
                }
                onClick={() => {
                  ref.current.removeFile();
                  formRef.current.reset();
                  setState({})
                  setShowUpdate(false);
                  setShowNota(false);
                  setShowAdd(true);
                  setUploadFlag(false);
                }}
                variant="warning"
              >
                Reset
                </Button1>
            </div>
          </div>
        </form>
      </div>

     
        <div className="container  my-2">
          <div className="row">
              <div className="col-md-12 mb-2" >
             <div className="row ballotCreationTableHeader" >
             <div className="col-md-1">
                  <h6>S.No</h6>
                </div>
                <div className="col-md-6">
                <h6>Candidate / Party Name (English and Official Language)</h6>
                </div>
                <div className="col-md-2">
                <h6>Photo</h6>
                </div>
                <div className="col-md-2">
                <h6>Action</h6>
                </div>
                <div className="col-md-1">
                <h6>Order</h6>
                </div>
             </div>
              </div>
              
            {ballotData?.length > 0 &&
              ballotData?.map((item, i) => {
                return (
                  <div className="col-md-12">
                    <div
                      className={ i%2==0?" row ballotCreation rowOrderOdd":"row ballotCreation rowOrderEven"}
                      style={{
                        // background: "#65ff6b80",
                        margin: "0px 0px 8px 0px",
                        paddingTop: "2px",
                        borderRadius: "7px",
                        fontFamily: "gist_hindi_font",
                      }}
                    >
                      <div
                        className="col-md-1 "
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {i + 1}
                       
                      </div>
                      <div
                        className="col-md-6"
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <div className="row">{item?.name_L1}</div>
                        {item?.party_L1 === undefined ||
                        item?.party_L1 === null ||
                        item?.party_L1 === "" ? (
                          <br />
                        ) : (
                          <div className="row">{item?.party_L1}</div>
                        )}
                        <div className="row">{item?.name_en}</div>
                        <div className="row">{item?.party_en}</div>
                      </div>
                      <div
                        className="col-md-2"
                        style={{ fontSize: "13px", lineHeight: "16px" }}
                      >
                        <img
                          src={item?.file}
                          style={{
                            height: "62px",
                            width: "72px",
                            border: "1px solid",
                            borderRadius: "7px",
                          }}
                        />
                      </div>
                      <div className="col-md-2 ballotIcon">
                        <a
                          class=" inlineIcon edit"
                          onClick={() => {
                            editData(i);
                          }}
                        ></a>
                        <a
                          class=" inlineIcon delete"
                          onClick={() => {
                            deleteData(i);
                          }}
                        ></a>
                      </div>
                     {item.name_en != "NONE OF THE ABOVE" ? <div className="col-md-1" style={{margin:"auto"}}>
                        <img src={up} style={{ height:"30px",width:"30px"}} onClick={() => handleSwapUp(i)} className={i === 0 && "upOrder"} disabled={i === 0} />
                        <img src={down} style={{ height:"30px",width:"30px"}} onClick={() => handleSwapDown(i)} className={i === ballotData.length - 1 && "downOrder"} disabled={i === ballotData.length - 1} />
                      {/* <button onClick={() => handleSwapUp(i)} disabled={i === 0}>
             Up
</button>
<button onClick={() => handleSwapDown(i)} disabled={i === ballotData.length - 1}>
             Down
</button> */}
                        </div>:
                        <div className="col-md-1">
                          </div>} 
                    </div>
                  </div>
                );
              })}

<div className="col-md-12" >
          <div className="row" style={{ justifyContent: "space-between" }}>
          <div style={{ marginLeft: "20px" }}>
                <Button
                onClick={() => {
                  saveDataAsDraft();
                }}
                btnClass="btn btn-success "
                value="Save As Draft"
              />
            </div>
            <div style={{ marginRight: "20px" }}>
              {
                (prevRes.length == ballotData.length && prevRes.length != 0 && !changeObserveonUpdate)
                ?  <Button1
                disabled={
                  (prevRes.length == ballotData.length && prevRes.length != 0 && !changeObserveonUpdate)
                    ? false
                    : true
                }
                onClick={() => {
                  saveData();
                }}
                variant="warning"
              >
                Preview
                </Button1>
                :  <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                      <Button1
                        disabled={
                          (prevRes.length == ballotData.length && prevRes.length != 0 && !changeObserveonUpdate)
                            ? false
                            : true
                        }
                        onClick={() => {
                          saveData();
                        }}
                        variant="warning"
                      >
                        Preview
                        </Button1>
                      </OverlayTrigger>
              }
       
</div>
          </div>
</div>


            {/* <Button
              onClick={() => {
                saveDataAsDraft();
              }}
              btnClass="btn btn-danger col-md-2 offset-md-9"
              value="Save As Draft"
            />
            <Button
              disabled={
                prevRes.length == ballotData.length && prevRes.length != 0
                  ? false
                  : true
              }
              onClick={() => {
                saveData();
              }}
              btnClass="btn btn-danger my-2 col-md-2 offset-md-9"
              value="Preview"
            /> */}
          </div>
        </div>
      
      {datap.isSuccess && (
        <div className="container box my-5">
          <div className="pdf-view">
            <iframe width="100%" height="500px" src={pdf}></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default BallotCreation;
